import { render } from "./LearningCourse.vue?vue&type=template&id=6e6d120a"
import script from "./LearningCourse.vue?vue&type=script&lang=js"
export * from "./LearningCourse.vue?vue&type=script&lang=js"

import "./LearningCourse.vue?vue&type=style&index=0&id=6e6d120a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__